<mat-form-field appearance="outline">
    <mat-label>Cloak</mat-label>
    <mat-select [(ngModel)]="selectedCloakType" name="visibility" appearance="outline">
        <mat-option *ngFor="let cloakType of cloakTypes" [value]="cloakType.CloakTypeId">
            {{ cloakType.UID }}
        </mat-option>
    </mat-select>
</mat-form-field>
<br />
<table mat-table *ngIf="personEnvelope" [dataSource]="searchRequestTypePreferences" class="mat-elevation-z8" matSort>
    <ng-container matColumnDef="Avatar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let searchRequestTypePreference">
            <mat-icon class="material-symbols-outlined">
                settings
            </mat-icon>
        </td>
    </ng-container>
    <ng-container matColumnDef="SearchRequestTypeUID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Search Type</th>
        <td mat-cell *matCellDef="let searchRequestTypePreference">
            {{ searchRequestTypePreference.SearchRequestTypeUID }}
        </td>
    </ng-container>
    <ng-container matColumnDef="SearchRequestName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Search Type</th>
        <td mat-cell *matCellDef="let searchRequestTypePreference">
            {{ searchRequestTypePreference.SearchRequestName }}
        </td>
    </ng-container>
    <!--<ng-container matColumnDef="IsRunSearchOnLoad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Run Search on Load</th>
        <td mat-cell *matCellDef="let searchRequestTypePreference">
            <mat-slide-toggle [(ngModel)]="searchRequestTypePreference.IsRunSearchOnLoad"></mat-slide-toggle>
        </td>
    </ng-container>-->
    <tr mat-header-row *matHeaderRowDef="displayedSearchRequestTypePreferences"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedSearchRequestTypePreferences"></tr>
</table>
